export const getResumeCritiqueLocalStorageKeysResume = (resumeId: number) => {
  return `${resumeId}_flag`
}
